export default __webpack_public_path__ + "static/icon-8-5-7616950f56e3b1dc24373c2404f09ab7.png";